import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft } = FiIcons;
const BACK_URL = "https://www.sunsetswipe.com/#vjwAditg61TZ_vjwAditg61TZ";

export default function TopBackBar() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY < 200);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50">
      <a
        href={BACK_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-2 bg-white/90 backdrop-blur-md text-deepNavy px-5 py-2.5 rounded-full shadow-apple border border-gray-100 hover:shadow-apple-hover hover:border-sage-light transition-all duration-300 hover:-translate-y-0.5 no-underline"
      >
        <div className="w-6 h-6 rounded-full bg-sage-lightest group-hover:bg-sage flex items-center justify-center transition-all duration-300">
          <SafeIcon icon={FiArrowLeft} className="w-3.5 h-3.5 text-mutedBlue group-hover:text-white transition-colors duration-300" />
        </div>
        <span className="text-sm font-semibold text-deepNavy tracking-wide">Back</span>
      </a>
    </div>
  );
}